import "./PowderTabletTestingInstruments.module.css";
import Header from "@/reusable_sections/Header";
import FamilyHero from "./sections/FamilyHero";
import InstrumentsComparison from "./sections/InstrumentsComparison";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function PowderTabletTestingInstrumentsPage() {
  return <div>
      <Header />
      <FamilyHero />
      <InstrumentsComparison />
      <Consultation />
      <Footer />
    </div>;
}